import "./Toggle.css";
import React, { useState } from "react";

export const Toggle = ({ onChange, left, right, label }) => {
	return (
		<div className="can-toggle">
			<input id="a" type="checkbox" onChange={onChange} />
			<label htmlFor="a">
				<div className="can-toggle__label-text">{label}</div>
				<div
					className="can-toggle__switch"
					data-checked={left}
					data-unchecked={right}
				></div>
			</label>
		</div>
	);
};
export const ToggleTemporary = ({
	onChange,
	label,
	name,
	value: initialValue,
	opts,
}) => {
	const [value, setValue] = useState(initialValue);
	const [left, right] = opts.map((o) => o.label);
	const handleChange = () => {
		const otherValue = opts
			.filter((o) => o.htmlValue != value)
			.reduce((_, o) => o.htmlValue, value);
		onChange({ input: name, value: otherValue });
	};

	return (
		<div className="can-toggle">
			<input id="a" type="checkbox" onChange={handleChange} />
			<label htmlFor="a">
				<div className="can-toggle__label-text">{label}</div>
				<div
					className="can-toggle__switch"
					data-checked={left}
					data-unchecked={right}
				></div>
			</label>
		</div>
	);
};

export const Select = ({
	onChange,
	name,
	value: initialValue,
	opts,
	hidden,
}) => {
	const [value, setValue] = useState(initialValue);
	const [left, right] = opts.map((o) => o.label);

	const handleChange = () => {
		const otherValue = opts
			.filter((o) => o.htmlValue != value)
			.reduce((_, o) => o.htmlValue, value);
		onChange({ target: { name, value: otherValue } });
		setValue(otherValue);
	};

	if (hidden === true) return null;
	return (
		<>
			<div className="can-toggle">
				<input id="a" type="checkbox" onChange={handleChange} />
				<label htmlFor="a">
					<div className="can-toggle__label-text">
						Tipo de documento
					</div>
					<div
						className="can-toggle__switch"
						data-checked={left}
						data-unchecked={right}
					></div>
				</label>
			</div>
		</>
	);
};
